import { StorageSet } from '../storage/index';
import { UseCase } from '../UseCase';

export class SetOAuthError implements UseCase<string | undefined, void> {
    private storageSet = new StorageSet<string>();

    execute(error?: string) {
        this.storageSet.execute({ key: 'oauth.error', value: error });
    }
}
